/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPhotoSensor2 = createReactComponent("outline", "photo-sensor-2", "IconPhotoSensor2", [["path", { "d": "M17 5h2a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-2", "key": "svg-0" }], ["path", { "d": "M7 19h-2a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2", "key": "svg-1" }], ["path", { "d": "M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", "key": "svg-2" }]]);

export { IconPhotoSensor2 as default };
//# sourceMappingURL=IconPhotoSensor2.mjs.map
